import type { Entry } from 'contentful';
import type { ComponentProps } from 'react';

import { Banner } from './banner';
import { Container } from './container';

// Register components here as their Contentful props are migrated to UI models.
// Until then, composition entries use the legacy renderer.
export const config = { banner: Banner, container: Container } as const;

export type Config = typeof config;
export type Model = {
    contentType: keyof Config;
    props: ComponentProps<Config[keyof Config]>;
};
export type CompositionItem = Entry | Model;
